import { AfterContentChecked, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { LocalStorageService } from 'src/app/Services/local-storage.service';
import { FilterFiltersBase, IFilter, IFilterFilters } from '../ifilter';

@Component({
    selector: '[app-valetstations-filter]',
    templateUrl: './valetstations-filter.component.html',
    styleUrls: ['./valetstations-filter.component.scss'],
    host: { 'class': 'control select' },
    standalone: false
})
export class ValetStationsFilterComponent extends FilterFiltersBase implements OnInit, IFilterFilters {

  constructor(private apiService: ApiServiceBase, route: ActivatedRoute) {
    super(route);
  }
  public FilterName: string = "valetstation";
  public Filters: any[] = [];
  public SelectedValetStation: any = "";
  public ValetStations: any;
  @Input()
  public QueryParamPrefix: string= '';

  ngOnInit(): void {
    var vals = super.GetParamFields(this.QueryParamPrefix + this.FilterName);
    if(vals != null) {
      this.SelectedValetStation = vals[2];
    }

    if (this.SelectedValetStation != "") {
      this.Filters.push({
        Property: "ValetStationId",
        Comparator: "==",
        Value: this.SelectedValetStation,
        FilterName: this.FilterName
      })
    }

    this.apiService.Get<any>("/valet/stations").then(result => {
      this.ValetStations = result;
    });
  }

  public addValetStationFilter(event: any) {
    var val = event.target.value;
    this.Filters = this.Filters.filter(x => x.Property != "ValetStationId");

    if (val != "") {
      this.Filters.push({
        Property: "ValetStationId",
        Comparator: "==",
        Value: val,
        FilterName: this.FilterName ,
      });

      this.SelectedValetStation = val;
    }
  }

  public ValetStationSelected(rateSet: any) {

    if (rateSet.Id == this.SelectedValetStation) {
      return true;
    }

    return false;
  }

}
